module.exports = __webpack_public_path__ + "static/media/avatar-1-profile.382606b5.png";